import { render, staticRenderFns } from "./v-language-selector.vue?vue&type=template&id=69b839a4&"
import script from "./v-language-selector.vue?vue&type=script&lang=js&"
export * from "./v-language-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports